import { HandlingTypeEnum } from './enums/handling-type.enum';

export interface IRefDimension {
  id?: number;
  activated?: boolean | null;
  handlingType?: HandlingTypeEnum | null;
  label?: string | null;
  width?: number | null;
  length?: number | null;
  maxHeight?: number | null;
  weight?: number | null;
  other?: number | null;
}

export class RefDimension {
  public id!: number;
  public activated: boolean = false;
  public handlingType!: HandlingTypeEnum;
  public label?: string;
  public width?: number;
  public length?: number;
  public maxHeight?: number;
  public weight?: number;
  public other?: number;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}

export function getRefDimensionIdentifier(refDimension: IRefDimension): number | undefined {
  return refDimension.id;
}
